import { render, staticRenderFns } from "./LinkCheckerSubmission.vue?vue&type=template&id=31a0c9fe&scoped=true&lang=pug&"
import script from "./LinkCheckerSubmission.vue?vue&type=script&lang=js&"
export * from "./LinkCheckerSubmission.vue?vue&type=script&lang=js&"
import style0 from "./LinkCheckerSubmission.vue?vue&type=style&index=0&id=31a0c9fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a0c9fe",
  null
  
)

export default component.exports